// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ace21015","627":"b968a6b3","653":"14db4f74","738":"29211f81","923":"47cb891c"}[chunkId] + ".chunk.js";
};